import on from '../util/Elements/on'
import { breakpoints } from '../vars'

export default function (Site, $) {
  Site.widget('equal-heights', {
    _create () {
      this.update()
      
      this.offResize = on(
        $(window),
        'resize',
        () => this.update()
      )
    },
    _transitionIn () {
      this.update()
    },
    _destroy () {
      this.offResize()
    },
    update () {
      const container = this.element
      const height1 = container.find("[class^='col-']:first-of-type").data('height')
      const width1  = container.find("[class^='col-']:first-of-type").data('width')
      const ratio1  = height1 / width1;

      const height2 = container.find("[class^='col-']:last-of-type").data('height')
      const width2  = container.find("[class^='col-']:last-of-type").data('width')
      const ratio2  = height2 / width2;

      const isVertical = ratio1 > ratio2

      container.find("img").parent().height(
        isVertical
          ? container.find("[class^='col-']:first-of-type img, [class^='col-']:last-of-type img").parent().height(container.find("[class^='col-']:last-of-type img").width() * ratio2)
          : container.find("[class^='col-']:first-of-type img, [class^='col-']:last-of-type img").parent().height(container.find("[class^='col-']:first-of-type img").width() * ratio1)
      )

      if (document.documentElement.clientWidth < breakpoints.md.min) {
        container.find("[class^='col-']:first-of-type img, [class^='col-']:last-of-type img").parent().height('auto')
      }
    }
  })
}